import api from './api';
import { User } from '../types';
import { demoDataService } from './demoDataService';
import { config } from '../config';

export const userApi = {
  // Get all users
  getUsers: async (): Promise<User[]> => {
    if (config.shouldUseDemoMode()) {
      return demoDataService.getUsers();
    }
    
    try {
      const response = await api.get('/admin/users');
      return response.data;
    } catch (error: any) {
      console.warn('Backend not available, falling back to demo mode');
      return demoDataService.getUsers();
    }
  },

  // Get user by ID
  getUser: async (userId: string): Promise<User> => {
    if (config.shouldUseDemoMode()) {
      const users = await demoDataService.getUsers();
      const user = users.find(u => u.id === userId);
      if (!user) throw new Error('User not found');
      return user;
    }
    
    try {
      const response = await api.get(`/admin/users/${userId}`);
      return response.data;
    } catch (error: any) {
      console.warn('Backend not available, falling back to demo mode');
      const users = await demoDataService.getUsers();
      const user = users.find(u => u.id === userId);
      if (!user) throw new Error('User not found');
      return user;
    }
  },

  // Create user
  createUser: async (userData: any): Promise<User> => {
    if (config.shouldUseDemoMode()) {
      throw new Error('User creation not available in demo mode');
    }
    
    const response = await api.post('/admin/users', userData);
    return response.data;
  },

  // Update user
  updateUser: async (userId: string, userData: any): Promise<User> => {
    if (config.shouldUseDemoMode()) {
      throw new Error('User update not available in demo mode');
    }
    
    const response = await api.put(`/admin/users/${userId}`, userData);
    return response.data;
  },

  // Activate user
  activateUser: async (userId: string): Promise<User> => {
    if (config.shouldUseDemoMode()) {
      return demoDataService.activateUser(userId);
    }
    
    try {
      const response = await api.post(`/admin/users/${userId}/activate`);
      return response.data;
    } catch (error: any) {
      console.warn('Backend not available, falling back to demo mode');
      return demoDataService.activateUser(userId);
    }
  },

  // Deactivate user
  deactivateUser: async (userId: string): Promise<User> => {
    if (config.shouldUseDemoMode()) {
      return demoDataService.deactivateUser(userId);
    }
    
    try {
      const response = await api.post(`/admin/users/${userId}/deactivate`);
      return response.data;
    } catch (error: any) {
      console.warn('Backend not available, falling back to demo mode');
      return demoDataService.deactivateUser(userId);
    }
  },

  // Delete user
  deleteUser: async (userId: string): Promise<void> => {
    if (config.shouldUseDemoMode()) {
      throw new Error('User deletion not available in demo mode');
    }
    
    await api.delete(`/admin/users/${userId}`);
  },
};
